// 파일 업로드 유틸리티

// 파일 크기 제한 (5MB)
export const MAX_FILE_SIZE = 5 * 1024 * 1024;

// 허용된 이미지 타입
export const ALLOWED_IMAGE_TYPES = [
  'image/jpeg',
  'image/jpg', 
  'image/png',
  'image/gif',
  'image/webp',
  'image/svg+xml' // SVG 파일 타입 추가
];

// 파일 유효성 검사
export function validateFile(file) {
  const errors = [];
  
  // 파일 크기 검사
  if (file.size > MAX_FILE_SIZE) {
    errors.push(`파일 크기는 ${MAX_FILE_SIZE / (1024 * 1024)}MB 이하여야 합니다.`);
  }
  
  // 파일 타입 검사
  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    errors.push('JPG, PNG, GIF, WebP 형식의 이미지만 업로드 가능합니다.');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
}

// 이미지 미리보기 URL 생성
export function createImagePreview(file) {
  if (!file) return null;
  
  return URL.createObjectURL(file);
}

// 이미지 미리보기 정리
export function revokeImagePreview(previewUrl) {
  if (previewUrl) {
    URL.revokeObjectURL(previewUrl);
  }
}

// 파일을 FormData로 변환
export function createFormData(data) {
  const formData = new FormData();
  
  Object.keys(data).forEach(key => {
    // lines 속성은 제외 (API 서버에서 허용하지 않음)
    if (key === 'lines') {
      return;
    }
    
    if (data[key] !== null && data[key] !== undefined && data[key] !== '') {
      if (key === 'imageFile' && data[key] instanceof File) {
        formData.append('image', data[key]); // imageFile을 image로 변환
      } else if (key === 'date' && typeof data[key] === 'string') {
        // HTML date input 값을 ISO 형식으로 변환
        const date = new Date(data[key]);
        if (!isNaN(date.getTime())) {
          formData.append('date', date.toISOString());
        }
      } else {
        formData.append(key, data[key]);
      }
    }
  });
  
  return formData;
}
